import Immutable from 'immutable';
import { config } from '../../config';

const LOAD_SUCCESS = 'plugin/LOAD_SUCCESS';
const ERROR = 'plugin/ERROR';

const initialState = Immutable.fromJS({
  error: null,
  loading: false,
  list: []
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_SUCCESS:
      return state
        .set('list', action.result);

    case ERROR:
      return state
        .set('error', action.error);

    default:
      return state;
  }
}

export const getAllPluginsByUuId = (uuid, custid, tag) => async (dispatch, getState, api) => {
  try {
    const data = await api.get(`${config.apiHost}/plugin/${uuid}`, { params: { custid, tag }});
    const result = Array.isArray(data)
      ? { showVideoPeelLogo: true, videos: data }
      : data;

    dispatch({ type: LOAD_SUCCESS, result });
    return result;
  } catch (error) {
    dispatch({ type: ERROR, error });
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/plugins.js